import { createFileRoute } from "@tanstack/react-router";
import { CityPicker } from "@/components/CityPicker";
import { SITE_URL } from "@/lib/seo";

export const Route = createFileRoute("/india/cities")({
  head: () => ({
    meta: [
      { title: "Gold Rate by City — India | DrHint" },
      { name: "description", content: "Choose your city to see today's live 24K, 22K & 21K gold rate in India — Delhi, Mumbai, Chennai and every major city." },
      { property: "og:title", content: "Gold Rate by City — India" },
      { property: "og:description", content: "Pick your city and see live gold prices, charts, and full breakdown." },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/india/cities` }],
  }),
  component: () => <CityPicker country="india" metal="gold" />,
});